module.exports = "<ng-content></ng-content>\n<div class=\"ptooltiptext\" *ngIf=\"tooltip&&tooltip!=''||tooltipHtml&&tooltipHtml!=''\">\n    <div [innerHtml]=\"_sanitizer.bypassSecurityTrustHtml(tooltip)\"></div>\n    <div [innerHtml]=\"_sanitizer.bypassSecurityTrustHtml(tooltipHtml)\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/polymer/tooltip/tooltip.component.html
// module id = ./src/app/components/polymer/tooltip/tooltip.component.html
// module chunks = main